import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components';

// 시, 분, 초를 입력받아서 사용하는 카운트다운 타이머
// setState로 상위 컴포넌트의 콜백 상태값을 받아서 반환하는 기능
// resetTrigger는 상위 컴포넌트의 [resetTimer,setResetTimer]의 resetTimer 값을 주고
// 다른 handle 함수에서 setResetTimer(((prev) => prev + 1))로 리셋가능함

const AlertSpan = styled.span<{ $isValid: boolean }>`
  color: ${({ $isValid }) => ($isValid ? '#39B95B' : '#FF5A5A')};
  font-size: 14px;
  font-weight: 500;
  /* padding: 10px; */
`;

interface Props {
  h?: number
  m?: number
  s?: number
  setState?: (v: boolean) => void
  isPaused?: boolean
  resetTrigger?: number
}

const CountdownTimer = ({
  h = 0,
  m = 0,
  s = 0,
  setState,
  isPaused = false,
  resetTrigger,
}: Props) => {
  const INTERVAL = 1000
  const calculateInitialTime = () => (h * 60 * 60 + m * 60 + s) * 1000
  const [timeLeft, setTimeLeft] = useState(calculateInitialTime())
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  // 타이머 리셋 트리거 (값이 바뀌면 초기화)
  useEffect(() => {
    setTimeLeft(calculateInitialTime())
  }, [resetTrigger, h, m, s])

  // 🧠 타이머 종료 시 setState 호출
  useEffect(() => {
    if (timeLeft === 0) {
      setState?.(true)
    }
  }, [timeLeft])

  // 타이머 실행 및 정지 제어
  useEffect(() => {
    if (isPaused || timeLeft <= 0) {
      if (timerRef.current) clearInterval(timerRef.current)
      return
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= INTERVAL) {
          clearInterval(timerRef.current!)

          return 0
        }
        return prev - INTERVAL
      })
    }, INTERVAL)

    return () => {
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [isPaused, timeLeft])

  const minutes = String(Math.floor((timeLeft / 1000 / 60) % 60)).padStart(2)
  const seconds = String(Math.floor((timeLeft / 1000) % 60)).padStart(2, '0')

  return <div>{
    timeLeft === 0 ?
    <AlertSpan $isValid={false}>
     시간 만료
    </AlertSpan>
    : 
    <AlertSpan $isValid={true}>
    {minutes}:{seconds}
    </AlertSpan>}
    </div>
}

export default CountdownTimer
